export default __webpack_public_path__ + "static/subset-Inter-Medium-2173bc5b5d77d73a88974ba7a7fee354.woff2";